import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Textlink (MUI-`Link`-Ersatz) auf `.sec-link`-Basis. */
export const Link = forwardRef(function Link({ className, ...rest }, ref) {
    return _jsx("a", { ref: ref, className: cn('sec-link', className), ...rest });
});
